export var ExpirationType;
(function (ExpirationType) {
    ExpirationType["MINUTES"] = "minutes";
    ExpirationType["HOURS"] = "hours";
    ExpirationType["DAYS"] = "days";
    ExpirationType["MONTHS"] = "months";
    ExpirationType["YEARS"] = "years";
})(ExpirationType || (ExpirationType = {}));
